import { render, staticRenderFns } from "./RedirectFromMobile.vue?vue&type=template&id=3b57542a"
import script from "./RedirectFromMobile.vue?vue&type=script&lang=ts"
export * from "./RedirectFromMobile.vue?vue&type=script&lang=ts"
import style0 from "./RedirectFromMobile.vue?vue&type=style&index=0&id=3b57542a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports